import React from 'react';
import { ProgressBar, colors } from '@cimpress/react-components';

const ProgressBarDemo = () => (
  <div className="row">
    <div className="col-md-12">
      <ProgressBar value={20} />
      <ProgressBar status="info" size="m" value={40} />
      <ProgressBar status="success" size="l" value={60} />
      <ProgressBar status="warning" size="xl" value={80} />
      <ProgressBar status="danger" value={100} />
      <ProgressBar color={colors.persimmon.base} value={30} />
    </div>
  </div>
);

export default ProgressBarDemo;
